import React from 'react';
import IbssTextField from "../../../../Components/Inputs/TextField/IbssTextField";
import { IbssComponent } from "../../../../Components/Core/BaseComponent/IbssComponent";
import { appContext } from "../../../../AppContext";
import IbssInputDropDown from "../../../../Components/Inputs/SelectList/IbssInputDropDown";
import { Box, Typography } from '@mui/material';
import MediaSelector, { IFile } from '../../../../Components/DialogLaunchers/MediaSelector/MediaSelector';
import IbssSwitchLabel from '../../../../Components/Inputs/Switch/IbssSwitchLabel';


class KpiForm extends IbssComponent<IProps, IState>
{
    private labels = appContext().labels;
    private kpiTypeOptions: IDropDownOption[];

    constructor(props: IProps)
    {
        super(props);

        this.kpiTypeOptions = [
            {
                label:this.labels.funcNumberSlider_S,
                value: 0
            },
            {
                label: this.labels.funcTextSlider_S,
                value: 1
            },
            {
                label: this.labels.funcNumberOnly_S,
                value: 2
            },
            {
                label: this.labels.funcTextOnly_S,
                value: 3
            }
        ];

    }

    public render(): JSX.Element
    {
        const { showErrors, errorFields } = this.props;

        return (
            <div>

                <IbssInputDropDown
                    id="kpitype"
                    inputLabel={this.labels.HubLabelType}
                    value={this.props.kpiPostType}
                    options={this.kpiTypeOptions}
                    onChange={(e) => this.props.onSignpostTypeChange(Number(e.target.value))}
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcLabel_S}
                    value={this.props.label}
                    onChange={(e) => this.props.onLabelChange(e.target.value)}
                    margin="normal"
                    required
                    error={showErrors && errorFields.label}
                    helperText={showErrors && errorFields.label ? this.labels.funcLabelRequired_L : ' '}
                />
                <Box sx={{ mt: 2 }}>
                    <IbssInputDropDown
                        id="kpi-order-dropdown"
                        fullWidth
                        inputLabel={this.labels.funcKPIOrder_S}
                        value={this.props.selectedKPIOrder}
                        onChange={(e) => this.props.onKpiOrderChange(e.target.value)}
                        options={this.props.signpostOrder.map(order => ({
                            value: order,
                            label: order
                        }))}
                    />
                </Box>
                <Box>
                    <Typography variant="h6" fontWeight={'normal'} mb={1}>{this.labels.funcChooseImage_S}</Typography>
                    <Typography variant="body1" className="ui-text-light">{this.labels.funcUploadAnImageInfo_D}</Typography>
                </Box>
                <Box className="option-box" my={2}>
                    <Box mt={1} display={'flex'} justifyContent={"space-between"}>
                        <Typography variant="body1">
                            <MediaSelector
                                options={this.props.images.map(i => ({ name: i.name, url: i.path }))}
                                imageSelected={file => this.props.onImageSelect(file.url)}
                                uploadFile={(filename, file, processAsMap) => this.props.onImageUpload(filename, file, processAsMap)}
                                defaultSelectedImage={this.props.imageUrl}
                            />

                        </Typography>
                    </Box>
                </Box>
                <IbssTextField
                    fullWidth
                    label={this.labels.funcLableMaximumCount_S}
                    value={this.props.maximumCount}
                    onChange={(e) => this.props.onMaximumCountChange(e.target.value)}
                    margin="normal"
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcKPILimit1_S}
                    value={this.props.kpiLimit1}
                    onChange={(e) => this.props.onKpiLimit1Change(e.target.value)}
                    margin="normal"
                    type='number'
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcKPILimit2_S}
                    value={this.props.kpiLimit2}
                    onChange={(e) => this.props.onKpiLimit2Change(e.target.value)}
                    margin="normal"
                    type='number'
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcTextBox1_S}
                    value={this.props.textBox1}
                    onChange={(e) => this.props.onTextBox1Change(e.target.value)}
                    required={this.props.isTextMandatory ? true : false}
                    margin="normal"
                    error={showErrors && errorFields.textBox1}
                    helperText={showErrors && errorFields.textBox1 ? this.labels.funcTextBox1Required_L : ' '} />

                <IbssTextField
                    fullWidth
                    label={this.labels.funcTextBox2_S}
                    value={this.props.textBox2}
                    onChange={(e) => this.props.onTextBox2Change(e.target.value)}
                    margin="normal"
                    required={this.props.isTextMandatory ? true : false}
                    error={showErrors && errorFields.textBox2}
                    helperText={showErrors && errorFields.textBox2 ? this.labels.funcTextBox2Required_L : ' '}
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcTextBox3_S}
                    value={this.props.textBox3}
                    onChange={(e) => this.props.onTextBox3Change(e.target.value)}
                    required={this.props.isTextMandatory ? true : false}
                    margin="normal"
                    error={showErrors && errorFields.textBox3}
                    helperText={showErrors && errorFields.textBox3 ? this.labels.funcTextBox3Required_L : ' '}
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcKPIValue_S}
                    value={this.props.initialKpiValue}
                    onChange={(e) => this.props.onInitialKpiValueChange(e.target.value)}
                    margin="normal"
                    error={showErrors && errorFields.initialKpiValue}
                    helperText={showErrors && errorFields.initialKpiValue ? this.labels.funcInitialKPIValueRequired_L : ' '}
                    type='number'
                    required
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcValueURL_S}
                    value={this.props.valueUrl1}
                    onChange={(e) => this.props.onValueUrl1Change(e.target.value)}
                    margin="normal"
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcActionLabel_S}
                    value={this.props.actionLabel}
                    onChange={(e) => this.props.onActionLabelChange(e.target.value)}
                    margin="normal"
                />
                <IbssTextField
                    fullWidth
                    label={this.labels.funcActionUri_S}
                    value={this.props.actionUri}
                    onChange={(e) => this.props.onActionUriChange(e.target.value)}
                    margin="normal"
                    required
                    error={this.props.showErrors && this.props.errorFields.actionUri}
                    helperText={this.props.showErrors && this.props.errorFields.actionUri ? this.labels.funcActionUriRequired_L : ' '}
                />
                <IbssSwitchLabel
                    checked={this.props.isEnabled === 1 ? true : false}
                    onChange={e => this.props.onStatusChange(e.target.checked)}
                    label={this.labels.HubLabelActive}
                />

            </div>
        )
    }
}
export default KpiForm;

export interface IProps
{
    label: string;
    onLabelChange: (value: string) => void;
    kpiPostType: number;
    onSignpostTypeChange: (value: number) => void;
    onKpiOrderChange: (value: string) => void;
    maximumCount: string;
    onMaximumCountChange: (value: string) => void;
    kpiLimit1: string;
    onKpiLimit1Change: (value: string) => void;
    kpiLimit2: string;
    onKpiLimit2Change: (value: string) => void;
    textBox2: string;
    onTextBox2Change: (value: string) => void;
    textBox1: string;
    onTextBox1Change: (value: string) => void;
    textBox3: string;
    onTextBox3Change: (value: string) => void;
    initialKpiValue: string;
    onInitialKpiValueChange: (value: string) => void;
    valueUrl1: string;
    onValueUrl1Change: (value: string) => void;
    actionLabel: string;
    onActionLabelChange: (value: string) => void;
    actionUri: string;
    onActionUriChange: (value: string) => void;
    images: IFile[];
    onImageUpload: (filename: string, file: FormData, processAsMap: boolean) => Promise<void>;
    showErrors: boolean;
    errorFields: IErroredFields;
    onImageSelect: (url: string) => void;
    imageUrl: string
    signpostOrder: string[];
    selectedKPIOrder: string;
    isTextMandatory: boolean;
    isEnabled: number;
    onStatusChange: (value: boolean) => void;
}
export interface IDropDownOption
{
    label: string;
    value: number
}
export interface IState {}
export interface IErroredFields
{
    label: boolean;
    textBox1: boolean;
    textBox2: boolean;
    textBox3: boolean;
    initialKpiValue: boolean;
    actionUri: boolean;
}